<template>
<div :style="coverStyle" class="search-structure-cover">
  <div class="cover-content">
    <div class="cover-head">
      <div>{{steps[step] === 'search-structure' ? 'SEARCH STRUCTURE' : (steps[step] === 'edit-structure' ? 'EDIT STRUCTURE' : 'SUBMIT')}}</div>
      <div class="close-button" @click="hidden"><i class="el-icon-close"></i></div>
    </div>

    <div v-show="steps[step]!=='submit'" class="search-structure">
      <el-input class="search-input" :value="query" @input="onInput" @keyup.enter.native="search(query)" size="large" placeholder="Name / Formula / SMILES / CHEMBL ID / HMDB ID / ZINC ID">
        <div class="search-input-button" @click="search(query)" slot="append">Search</div>
      </el-input>
    </div>

    <div class="search-result-panel" v-show="steps[step]==='search-structure'" v-if="queryResult">
      <div class="search-result-row" v-for="(c, i) in queryResult" :key="i" @click="selectCompound(c)">
        <div class="search-result-row-left">
          <canvas :id="`canvas-${i}`" width="200px" height="200px"></canvas>
        </div>
        <div class="search-result-row-right">
          <div class="search-result-pref-name">{{c.pref_name}}</div>
          <div class="search-result-compound-name">{{c.compound_name}}&nbsp;</div>
          <div class="search-result-synonyms"><b>Synonyms</b>: {{c.synonyms}}&nbsp;</div>
          <div class="search-result-formula"><b>Formula</b>: {{c.full_molformula}}&nbsp;</div>
          <div class="search-result-weight"><b>Weight</b>: {{c.full_mwt}}&nbsp;</div>
          <div class="search-result-smiles"><b>Smiles</b>: {{c.canonical_smiles}}&nbsp;</div>
        </div>
        <div style="clear:both"></div>
      </div>
    </div>

    <div class="search-structure-wait" v-if="step===0&&!queryResult">
      <i class="el-icon-loading"></i>
    </div>

    <div :style="searchStructureStyle"><div class="view-structure" id="search-structure"></div></div>

    <div v-show="steps[step]==='submit'" class="submit-area"><submit ref="submit" :compound="compound"></submit></div>

    <div class="search-structure-buttons" v-if="step>0">
      <el-button class="search-structure-prev" type="primary" v-if="!isQuerySmiles && step > 0" @click="step -= 1">Prev</el-button>
      <el-button class="search-structure-next" type="primary" v-if="step === 1" @click="next">Next</el-button>
      <el-button class="search-structure-submit" type="primary" v-if="step === steps.length - 1" @click="submit">Submit</el-button>
    </div>

  </div>
</div>
</template>

<script>
// import { Kekule } from 'kekule'
import axios from 'axios'
import Submit from './Submit.vue'
// import SmilesDrawer from 'smiles-drawer/dist/smiles-drawer.min.js'

export default {
  name: 'SearchStructure',

  data () {
    return {
      step: 0,
      steps: ['search-structure', 'edit-structure', 'submit'],
      compound: '',
      queryResult: '',
      isQeurySmiles: false
    }
  },

  components: {
    Submit
  },

  computed: {
    coverStyle () {
      return this.value ? {
        left: 0, right: 0, top: 0, bottom: 0
      } : {
        left: '-300%', right: '300%', top: 0, bottom: 0
      }
    },

    searchStructureStyle () {
      return this.steps[this.step] === 'edit-structure' ? {
        margin: '0px auto'
      } : {
        position: 'fixed', left: '-300%', right: '300%'
      }
    }
  },

  props: [ 'value', 'query' ],

  methods: {
    search (query) {
      let v = this

      this.$refs.submit.setTitle(query)

      v.show()

      v.isSmiles(query, (tree) => {
        v.step = 2
        v.compound = query
        v.isQuerySmiles = true
      }, (error) => {
        console.log(error)
        v.isQuerySmiles = false
        v.step = 0
        v.queryResult = ''
        axios({
          method: 'get',
          url: v.$store.state.host + '/dokhlab/actions/drift/search_compound?query=' + encodeURIComponent(query),
          withCredentials: true
        }).then(response => {
          v.queryResult = response.data
          for (let i in v.queryResult) {
            v.smilesPromise.then(() => {
              window.SmilesDrawer.parse(v.queryResult[i].canonical_smiles, function (tree) {
                setTimeout(() => { v.smilesDrawer.draw(tree, `canvas-${i}`, 'light', false) }, 500)
              })
            })
          }
        }).catch(() => {
          alert('Search Failed!')
          v.hidden()
        })
      })
    },

    isFormula (s) {
      let r = s.trim().match(/^((\(?)([A-Z])([a-z]*)([0-9]*)(\))?([0-9]*))+$/g)
      console.log('formula')
      console.log(r != null)
      return r != null
    },

    isSmiles (s, resolve, reject) {
//      let r = s.trim().match(/^([abcdefghiklmnopqrstuvwxyz0-9@+()%=#\\/$]|-|\[|\]){6,}$/ig)
//      console.log('smiles')
//      console.log(r != null)
//      return r != null
      this.smilesPromise.then(() => {
        window.SmilesDrawer.parse(s, function (tree) {
          resolve(tree)
        }, function (error) {
          reject(error)
        })
      })
    },

    onInput (e) {
      this.$emit('change', e)
    },

    show () {
      this.$emit('input', true)
    },

    hidden () {
      this.$emit('input', false)
    },

    selectCompound (c) {
      let v = this
      v.step = 1

      let mol = window.Kekule.IO.loadFormatData(c.molfile, 'mol')
      v.chemViewer.setChemObj(mol)
    },

    initKekule () {
      let v = this
      v.$store.state.kekulePromise.then(() => {
        v.chemViewer = new window.Kekule.ChemWidget.Viewer(document)
        v.chemViewer.setDimension('100%', '400px')
        v.chemViewer.appendToElem(document.getElementById('search-structure'))
        v.chemViewer.setEnableToolbar(true).setEnableDirectInteraction(true).setEnableEdit(true)
      })
    },

    next () {
      let v = this
      if (this.step === 1) {
        let mol = v.chemViewer.getChemObj()
        v.compound = window.Kekule.IO.saveFormatData(mol, 'smi')
      }
      v.step += 1
    },

    submit () {
      this.$refs.submit.submit()
      this.hidden()
    }
  },

  mounted () {
    let v = this
    v.initKekule()
    v.smilesPromise = v.$store.state.smilesDrawerPromise.then(() => {
      v.smilesDrawer = new window.SmilesDrawer.Drawer({ width: 200, height: 200 })
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.search-structure-cover {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
}

.cover-content {
  width: 1000px;
  margin: 50px auto;
  /*
  background-color: white;
  */
  position: relative;
  background-color: #dadada;
}

.cover-head {
  position: relative;
  font-size: 16px;
  padding: 10px;
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.view-structure-background {
  background-color: #dadada;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
}

.view-structure {
  width: '900px'
}

.search-structure-buttons {
  width: 900px;
  margin: 20px auto;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.search-structure-next {
  margin: 0px 20px 10px auto;
}

.search-structure-prev {
  margin: 0px auto 10px 20px;
}

.search-structure-submit {
  margin: 0px 20px 10px auto;
}

.close-button {
  margin-left: auto;
  margin-right: 0;
  z-index: 99;
  cursor: pointer;
  font-size: 20px;
  opacity: 0.5;
}

.close-button:hover {
  opacity: 1;
}

.search-structure {
  width: 100%;
  background-color: $theme-color;
  color: white;
  font-size: 16px;
}

.search-input {
  margin-left: 50px;
  margin-top: 20px;
  margin-bottom: 20px;
  width: 850px;
}

.search-input-button {
  cursor: pointer;
}

.submit-area-background {
  background-color: white;
  width: 100%;
}

.submit-area {
  width: 700px;
  margin: 0px auto;
  padding: 10px;
}

.el-button--primary {
  background-color: $theme-color;
  border-color: $theme-color;
}

.el-button--primary:hover {
  opacity: 0.5;
}

.search-result-panel {
  font-size: 14px;
  color: $font-grey;
  max-height: 500px;
  overflow-x: hidden;
  overflow-y: auto;
}

.search-result-head {
  display: flex;
  flex-direction: row;
  weight: 100%;
  padding: 10px;
  font-weight: 600;
}

.search-result-row {
  background-color: white;
  box-sizing: border-box;
  padding: 0;
  cursor: pointer;
  margin: 20px 30px 20px 30px;
}

.search-result-row:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.search-result-row-left {
  float: left;
  width: 200px;
}

.search-result-row-right {
  float: left;
  width: 600px;
  margin: 20px;
}

.search-result-pref-name {
  font-weight: 800;
}

.search-result-compound-name {
  width: 100%;
  margin-bottom: 15px;
}

.search-result-synonyms {
  width: 100%;
}

.search-result-formula {
  width: 100%;
}

.search-result-weight {
  width: 100%;
}
.search-result-smiles {
  width: 100%;
}

.search-structure-wait {
  font-size: 100px;
  height: 200px;
  vertical-align: middle;
  text-align: center;
  color: $font-grey;
}

</style>

